export function buildPageShellClass(extraClass?: string) {
  return ['w-full', 'h-full', 'min-h-0', 'flex', 'flex-col', 'p-2', 'gap-2', extraClass]
    .filter(Boolean)
    .join(' ');
}
